export const SignupForm = {
  flow: 'column',
  gap: 'A',
  flex: '1',
  '@mobileL': {
    minWidth: '100%'
  },
  childExtends: 'InputField',
  childProps: {
    width: '100%',
    '@mobileL': {
      maxWidth: '100%'
    },
    Title: { tag: 'span' },
    Input: {
      width: '100%',
      theme: 'field',
      background: 'hover',
      minHeight: 'controlH',
      round: 'radiusControl',
      fontSize: 'Z2',
      padding: '0 A',
      onInput: (ev, el, s) => {
        s.update({
          [el.parent.key.toLowerCase()]: el.node.value
        })
      }
    }
  },
  Email: {
    Title: {
      text: '{{ auth.signup.email | polyglot }}',
      padding: '- - 0'
    },
    Input: {
      autofocus: true,
      autocomplete: 'email',
      name: 'email',
      ariaLabel: (el) => el.call('polyglot', 'auth.signup.email'),
      autocapitalize: 'none',
      spellcheck: false,
      required: true,
      type: 'email',
      value: (el, s) => s.email || '',
      // A white-label host never shows the platform's own address as the
      // example (it named symbo.ls on a tenant's signup).
      placeholder: (el, s) =>
        el.call(
          'polyglot',
          s && s.root && s.root.whitelabelBrand
            ? 'auth.whitelabel.emailPlaceholder'
            : 'auth.signup.emailPlaceholder'
        ),
      disabled: (el, s) => !!s.hasToken
    }
  },
  Name: {
    Title: {
      text: '{{ auth.signup.name | polyglot }}',
      padding: '- - 0'
    },
    Input: {
      autocomplete: 'name',
      name: 'name',
      ariaLabel: (el) => el.call('polyglot', 'auth.signup.name'),
      required: true,
      value: (el, s) => s.name || '',
      placeholder: (el) => el.call('polyglot', 'auth.signup.namePlaceholder'),
      type: 'text'
    }
  },
  Password: {
    Title: {
      text: '{{ auth.signup.password | polyglot }}',
      padding: '- - 0'
    },
    Input: {
      autocomplete: 'new-password',
      name: 'password',
      ariaLabel: (el) => el.call('polyglot', 'auth.signup.password'),
      value: (el, s) => s.password || '',
      placeholder: (el) => el.call('polyglot', 'auth.signup.password'),
      required: true,
      type: 'password',
      onInput: (ev, el, s) => {
        // Typing again withdraws a refusal the page printed for the old
        // password (`passwordRefused` is the sign-up page's own key — written
        // only when it is set, so a host that never declared it is left alone).
        s.update(
          s.passwordRefused
            ? { password: el.node.value, passwordRefused: false }
            : { password: el.node.value }
        )
      }
    }
  },
  ModalFooter: {
    // A div, not the label `childExtends: 'InputField'` makes of it: a label
    // forwards a click on ANY text beside its button to that button, so the
    // links and lines a page puts under the button (the sign-up page's "Sign
    // in" and legal links) would submit the form when pressed.
    tag: 'div',
    // White-label host: flush with the fields (the brand footer's '0 -X'
    // bleed is a modal affordance; on the branded card it set the button
    // off the field edges).
    isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
    '.isBranded': { margin: '0', padding: 'Z 0 0' },
    padding: 'B1 - - -',
    CheckButton: {
      // White-label host: the tenant accent (inert on the platform).
      extends: ['WhitelabelAccent', 'CheckButton'],
      text: (el, s) =>
        el.call('polyglot', s.loading ? 'auth.signup.creating' : 'auth.signup.submit'),
      disabled: (el, s) => !!s.loading,
      opacity: (el, s) => (s.loading ? '.7' : '1'),
      cursor: (el, s) => (s.loading ? 'wait' : 'pointer'),
      pointerEvents: (el, s) => (s.loading ? 'none' : 'auto'),
      minHeight: 'controlH',
      padding: '0 A',
      fontSize: 'Z2',
      fontWeight: '700',
      type: 'submit',
      icon: null
    },
    Title: null,
    Input: null
  }
}
